/** *************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/** *************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE9, IE10 and IE11 requires all of the following polyfills. **/
// Import 'core-js/es6/symbol';
// Import 'core-js/es6/object';
// Import 'core-js/es6/function';
// Import 'core-js/es6/parse-int';
// Import 'core-js/es6/parse-float';
// Import 'core-js/es6/number';
// Import 'core-js/es6/math';
// Import 'core-js/es6/string';
// Import 'core-js/es6/date';
// Import 'core-js/es6/array';
// Import 'core-js/es6/regexp';
// Import 'core-js/es6/map';
// Import 'core-js/es6/weak-map';
// Import 'core-js/es6/set';

/** IE10 and IE11 requires the following for NgClass support on SVG elements */
// Import 'classlist.js';  // Run `npm install --save classlist.js`.

/** IE10 and IE11 requires the following for the Reflect API. */
// Import 'core-js/es6/reflect';

/** Evergreen browsers require these. **/
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
// Import 'core-js/es7/reflect';

/**
 * Web Animations `@angular/platform-browser/animations`
 * Only required if AnimationBuilder is used within the application and using IE/Edge or Safari.
 * Standard animation support in Angular DOES NOT require any polyfills (as of Angular 6.0).
 **/
// Import 'web-animations-js';  // Run `npm install --save web-animations-js`.

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 */

// (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
// (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
// (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

/*
 * In IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 * with the following flag, it will bypass `zone.js` patch for IE/Edge
 */
// (window as any).__Zone_enable_cross_context_check = true;

/** *************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.

// Patch rxjs APIs to run in the correct Zone
// (https://github.com/angular/zone.js/blob/master/NON-STANDARD-APIS.md#usage-1)
import 'zone.js/dist/zone-patch-rxjs';

// Angular does not zone patch resize-observer.
// This means that change detection is not triggered in certain async situations.
// To be safe its recommended to add the zone patch for resize-observer in your polyfill.ts.
import 'zone.js/dist/zone-patch-resize-observer';

/** *************************************************************************************************
 * APPLICATION IMPORTS
 */

// Inspect mode: suppress console logs as early as possible without importing app code
(function () {
  try {
    const hasInspect = window.location.search.includes('inspectWithIframe=true');
    if (hasInspect) {
      const noop = () => {};
      console.log = noop;
      console.info = noop;
      console.debug = noop;
      console.warn = noop;
      console.error = noop;
      // Common console helpers
      (console as any).group = noop;
      (console as any).groupCollapsed = noop;
      (console as any).groupEnd = noop;
      console.trace = noop as any;
      console.dir = noop as any;

      // Stub analytics SDKs to prevent initialization
      (window as any).FS = (window as any).FullStory = noop;
      (window as any).Intercom = noop;

      // Block loading of FullStory/Intercom scripts
      const shouldBlockSrc = (src: string | null | undefined) => {
        if (!src) {
          return false;
        }
        const url = String(src).toLowerCase();
        return url.includes('fullstory') || url.includes('intercom');
      };
      const origAppendChild = Element.prototype.appendChild as <T extends Node>(node: T) => T;
      Element.prototype.appendChild = function <T extends Node>(this: Element, child: T): T {
        try {
          if (child instanceof HTMLScriptElement) {
            const src: string | null = child.src || child.getAttribute('src');
            if (shouldBlockSrc(src)) {
              return child as T; // skip injecting blocked script
            }
          }
        } catch {
          /* no-op */
        }
        return origAppendChild.call(this, child) as T;
      } as typeof Element.prototype.appendChild;
    }
  } catch (e) {
    // ignore
  }
})();
